import React from 'react';
import '../../styles/customModalStyles.css';
import { Modal } from 'react-responsive-modal';
import CancelSharpIcon from '@material-ui/icons/CancelSharp';

function CustomModal({ open, setOpen, exitIconCls, onCloseModal, children }) {
  return (
    <Modal
      open={open}
      onClose={onCloseModal}
      center
      closeIcon={<CancelSharpIcon className={exitIconCls} />}
    >
      {children}
    </Modal>
  );
}

export default CustomModal;
